import {useState} from 'react'
import {getEnterprise, getEnterpriseBySearch, getEnterpriseById} from '../services'
import {EnterpriseModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
import {getEnterpriseByOrder} from '../../lavanderia/services'
import { useAuth } from '../../../hooks/useAuth'

export const ENTERPRISE_SEARCH_MIN_LENGTH = 4
export const ENTERPRISE_SEARCH_DEBOUNCE_MS = 500

const useEnterpriseService = () => {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)
  const [enterprise, setEnterprise] = useState<SelectModel[]>([])
  const [enterPriseByOrders, setEnterPriseByOrders] = useState<SelectModel[]>([])

  const getEnterpriseData = async (enterpriseParams: EnterpriseModel) => {
    setLoading(true)
    try {
      const response = await getEnterpriseService(enterpriseParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching client data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getEnterpriseBySearchData = async (enterpriseParams: EnterpriseModel) => {
    setLoading(true)
    try {
      const response = await getEnterpriseBySearch(enterpriseParams, 1, 99)
      return response.data.data
    } catch (error) {
      console.error('Error fetching client data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getEnterpriseService = async (enterpriseParams: EnterpriseModel) => {
    let obj: EnterpriseModel = {
      isCombo: true,
      ...enterpriseParams,
    }
    return await getEnterprise(obj, 1)
  }

  const updateClientList = (mappedSites: {value: string; label: string}[]) => {
    setEnterprise(mappedSites)
  }

  const getEnterpriseList = async (enterpriseParams: EnterpriseModel = {}) => {
    try {
      const data = await getEnterpriseData(enterpriseParams)
      const mappedSites = mapDataSelect(data, 'id', 'nombre')
      updateClientList(mappedSites)
    } catch (error) {
      console.error('Error fetching client data:', error)
    }
  }

  const getEnterpriseBySearchList = async (enterpriseParams: EnterpriseModel) => {
    try {
      const data = await getEnterpriseBySearchData(enterpriseParams)
      const mappedSites = mapDataSelect(data, 'id', 'nombre')
      updateClientList(mappedSites)
    } catch (error) {
      console.error('Error fetching client data:', error)
    }
  }

  const getEnterpriseSearchOptions = async (nombre: string): Promise<SelectModel[]> => {
    try {
      const data = await getEnterpriseBySearchData({nombre})
      return mapDataSelect(data, 'Value', 'Text')
    } catch (error) {
      console.error('Error fetching client data:', error)
      return []
    }
  }

  const getEnterpriseOptionById = async (id?: string | number): Promise<SelectModel | null> => {
    if (!id) return null
    try {
      const {data: response} = await getEnterpriseById(String(id))
      const item = response.data as EnterpriseModel | undefined
      if (!item) return null
      return {value: item.id, label: item.nombre} as SelectModel
    } catch (error) {
      console.error('Error fetching enterprise by id:', error)
      return null
    }
  }

  const getEnterpriseByOrderList = async () => {
    try {
      const response = await getEnterpriseByOrder()
      const mappedSites = mapDataSelect(response.data.data, 'Id', 'Nombre')
      setEnterPriseByOrders(mappedSites)
    } catch (error) {
      console.error('Error fetching client data:', error)
    }
  }

  const handleClear = () => {
    setEnterprise([])
    setEnterPriseByOrders([])
  }


  return {
    loading,
    enterprise,
    handleClear,
    getEnterpriseList,
    enterPriseByOrders,
    getEnterpriseByOrderList,
    getEnterpriseBySearchList,
    getEnterpriseSearchOptions,
    getEnterpriseOptionById,
  }
}
export default useEnterpriseService
